module.exports = __webpack_public_path__ + "img/avalizequest.bb4d2d5c.png";